export const roleBadgeVariants = {
  FDL: 'bg-chat-message-badgebki-fill',
  LF: 'bg-chat-message-badgelf-fill',
  ZB: 'bg-chat-message-badgezb-fill',
  ZV: 'bg-chat-message-badgezb-fill',
  BKI: 'bg-chat-message-badgebki-fill',
  Ad: 'bg-chat-message-badgebki-fill',
  EMBZ: 'bg-chat-message-badgebki-fill',
  Bü: 'bg-chat-message-badgebu-fill',
  All: 'bg-chat-message-badgeall-fill',
} as const;

export const roleChatMessageVariants = {
  FDL: 'bg-chat-message-bki-fill',
  LF: 'bg-chat-message-lf-fill',
  ZB: 'bg-chat-message-zb-fill',
  ZV: 'bg-chat-message-zb-fill',
  BKI: 'bg-chat-message-bki-fill',
  Bü: 'bg-chat-message-bu-fill',
  Ad: 'bg-chat-message-bki-fill',
  EMBZ: 'bg-chat-message-bki-fill',
  All: 'bg-chat-message-all-fill',
} as const;

export const roleAvatarVariants = {
  FDL: 'bg-chat-message-avatarbki-fill text-chat-message-avatarbki-color',
  LF: 'bg-chat-message-avatarlf-fill text-chat-message-avatarlf-color',
  ZB: 'bg-chat-message-avatarzb-fill text-chat-message-avatarzb-color',
  ZV: 'bg-chat-message-avatarzb-fill text-chat-message-avatarzb-color',
  BKI: 'bg-chat-message-avatarbki-fill text-chat-message-avatarbki-color',
  Bü: 'bg-chat-message-avatarbu-fill text-chat-message-avatarbu-color',
  Ad: 'bg-chat-message-avatarbki-fill text-chat-message-avatarbki-color',
  EMBZ: 'bg-chat-message-avatarbki-fill text-chat-message-avatarbki-color',
} as const;

export const roleTagVariants = {
  FDL: 'bg-chat-message-tag-bki-fill text-chat-message-badgebki-fill border-chat-message-tag-bki-stroke',
  LF: 'bg-chat-message-tag-lf-fill text-chat-message-badgelf-fill border-chat-message-tag-lf-stroke',
  ZB: 'bg-chat-message-tag-zb-fill text-chat-message-badgezb-fill border-chat-message-tag-zb-stroke',
  ZV: 'bg-chat-message-tag-zb-fill text-chat-message-badgezb-fill border-chat-message-tag-zb-stroke',
  BKI: 'bg-chat-message-tag-bki-fill text-chat-message-badgebki-fill border-chat-message-tag-bki-stroke',
  Bü: 'bg-chat-message-tag-bu-fill text-chat-message-badgebu-fill border-chat-message-tag-bu-stroke',
  Ad: 'bg-chat-message-tag-bki-fill text-chat-message-badgebki-fill border-chat-message-tag-bki-stroke',
  EMBZ: 'bg-chat-message-tag-bki-fill text-chat-message-badgebki-fill border-chat-message-tag-bki-stroke',
  All: 'bg-muted text-chat-subtext border-chat-stroke',
} as const;

export const roleBadgeHoverVariants = {
  FDL: 'hover:bg-chat-message-bki-fill',
  LF: 'hover:bg-chat-message-lf-fill',
  ZB: 'hover:bg-chat-message-zb-fill',
  ZV: 'hover:bg-chat-message-zb-fill',
  BKI: 'hover:bg-chat-message-bki-fill',
  Bü: 'hover:bg-chat-message-bu-fill',
  Ad: 'hover:bg-chat-message-bki-fill',
  EMBZ: 'hover:bg-chat-message-bki-fill',
  All: 'hover:bg-chat-message-badgesender-fill',
} as const;

export const roleBadgeSelectedHoverVariants = {
  FDL: 'hover:bg-chat-message-badgebki-fill',
  LF: 'hover:bg-chat-message-badgelf-fill',
  ZB: 'hover:bg-chat-message-badgezb-fill',
  ZV: 'hover:bg-chat-message-badgezb-fill',
  BKI: 'hover:bg-chat-message-badgebki-fill',
  Ad: 'hover:bg-chat-message-badgebki-fill',
  EMBZ: 'hover:bg-chat-message-badgebki-fill',
  Bü: 'hover:bg-chat-message-badgebu-fill',
  All: 'hover:bg-chat-message-badgeall-fill',
} as const;

export function getRoleBadgeClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return roleBadgeVariants[shortName as keyof typeof roleBadgeVariants] ?? '';
}

export function getChatMessageClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return roleChatMessageVariants[shortName as keyof typeof roleChatMessageVariants] ?? '';
}

export function getRoleBadgeHoverClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return roleBadgeHoverVariants[shortName as keyof typeof roleBadgeHoverVariants] ?? '';
}

export function getRoleBadgeSelectedHoverClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return (
    roleBadgeSelectedHoverVariants[shortName as keyof typeof roleBadgeSelectedHoverVariants] ?? ''
  );
}

export function getRoleAvatarClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return roleAvatarVariants[shortName as keyof typeof roleAvatarVariants] ?? '';
}

export function getRoleTagClassName(shortName: string | null) {
  if (!shortName) {
    return '';
  }

  return roleTagVariants[shortName as keyof typeof roleTagVariants] ?? '';
}
